import { isHiddenEl } from "./utils"

/**
 * フォーカス対象を取得するセレクタ
 */
const FOCUSABLE_ELEMENTS = [
	"a",
	"button:not([disabled])",
	"input:not([disabled])",
	"textarea:not([disabled])",
	"select:not([disabled])",
	"details",
	"[tabindex]:not([tabindex^='-']):not(.dummyTabTrap)"
]

export default class TabTrap {
	/** @type {HTMLElement} */
	#el
	/** @type {HTMLElement} */
	#dummyTrapEl
	constructor (el) {
		this.#el = el
		this.#dummyTrapEl = document.createElement("div")
		this.#dummyTrapEl.setAttribute("tabindex", "0")
		this.#dummyTrapEl.classList.add("dummyTabTrap")

		if (this.#el.firstChild) {
			this.#el.insertBefore(this.#dummyTrapEl, this.#el.firstChild)
		} else {
			this.#el.appendChild(this.#dummyTrapEl)
		}
		this.#el.addEventListener("keydown", (e) => { this.tabTrap(e) })
	}

	focusDummy () {
		// fade-inアニメーションが使われていると、0.2sのうちの1%アニメーションが進むまではdisplay:noneが適用されていて、
		// focusができないため、少しだけ待つ
		setTimeout(() => {
			this.#dummyTrapEl.focus()
		}, 200)
	}

	tabTrap (e) {
		if (e.key === "Tab") {
			// デフォルトのタブ移動を無効化
			e.preventDefault()
			// キーイベントは止める(ネストした場合、子要素のイベントを親が拾ってしまうため)
			e.stopPropagation()

			// フォーカス可能な要素が無ければ何もしない
			const elements = this.getFocusableElements()
			if (elements.length === 0) return

			// フォーカスされている要素がダイアログ内に存在しなければ、初期表示時と同様、
			// 最初の要素をフォーカスする
			// FIXME デッドコードになってる
			const currentFocused = document.activeElement
			if (!this.#el.contains(currentFocused)) {
				this.focusFirstElement()
				return
			}

			// ダイアログ内でタブ移動する
			const focusedIndex = elements.indexOf(currentFocused)
			if (e.shiftKey) {
				if (focusedIndex !== 0) {
					elements[focusedIndex - 1].focus()
				} else {
					elements[elements.length - 1].focus()
				}
			} else {
				if (focusedIndex !== elements.length - 1) {
					elements[focusedIndex + 1].focus()
				} else {
					elements[0].focus()
				}
			}
		}
	}

	getFocusableElements () {
		return [...this.#el.querySelectorAll(FOCUSABLE_ELEMENTS.join(","))].filter(el => {
			return !isHiddenEl(el)
		})
	}

	focusFirstElement () {
		const elements = this.getFocusableElements()
		if (elements.length > 0) {
			const target = this.#el.querySelector("[autofocus]") || elements[0]
			target.focus()
		}
	}
}
